/** Iniciais para o avatar: primeira e última palavra, no máximo dois caracteres. */
export function initialsOf(value: string): string {
  const words = value
    .trim()
    .split(/[\s@._-]+/)
    .filter(Boolean);

  if (words.length === 0) return '?';

  const first = words[0]?.[0] ?? '';
  const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? '') : '';

  return (first + last).toUpperCase();
}
